import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { IDriver } from '@/modules/driver/model/driver';
import { DescriptionList, RowWrapper } from '@/shared/view/DescriptionList';
import { Icon } from '@src-common/view/components/Icon';

import s from './OrdersInfo.module.css';

interface IProps {
  driver: IDriver;
  className?: string;
}

const OrdersInfo = ({ className, driver }: IProps) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<['orders', string, RowWrapper]> => [
      [
        'orders',
        intl.formatMessage({
          defaultMessage: 'See All Orders',
          id: 'ggrksM',
          description: 'Driver screen: Orders section link',
        }),
        ({ children }) => (
          <Link to={`/journeys?for=${driver.id}`} className={s.link}>
            {children}
          </Link>
        ),
      ],
    ],
    [driver.id, intl],
  );

  const values = {
    orders: () => <Icon icon={'chevron-to-end'} className={s.linkIcon} />,
  };

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Orders',
        id: 'FzsDOj',
        description: 'Driver screen: Orders section heading',
      })}
      className={className}
      titles={titles}
      values={values}
    />
  );
};

export { OrdersInfo };
